import { Resource } from 'model/Resource';
import { UserModel } from 'api/dto/User.dto';
import { PaginationModel } from 'model/Pagination.dto';

export const STORE_NAME = 'users';

export namespace UsersState {
  export type Domain = {
    list: Resource<UserModel[]>;
    pagination: PaginationModel | null;
  };

  export const INITIAL_DOMAIN: Domain = {
    list: Resource.createPendingResource<UserModel[]>(),
    pagination: null,
  };
}
